import { connect } from 'react-redux';
import Overview from '../components/Overview/Overview';
import { fetchPens, fetchBadges, changeCategory } from '../actions/middleware/overview';
import {
    openCategories,
    closeCategories,
    setCurrentDisplayLocale,
    setIsLoading,
    setActiveBadges,
} from '../actions/actionCreators/overview';

function getUniqueCategories(pens) {
    let uniqueCategories = [];
    pens.map(pen => pen.category).forEach(category => {
        let foundCategory = false;
        uniqueCategories.forEach(uniqueCategory => {
            if (uniqueCategory.id === category.id) {
                foundCategory = true;
            }
        });
        if (foundCategory) {
            return;
        }
        uniqueCategories.push(category);
    });
    return uniqueCategories;
}

function mapStateToProps(state) {
    const uniqueCategories = getUniqueCategories(state.overview.pens);
    return {
        recentPen: state.configurator.penSlug || null,
        locale: state.app.locale,
        pens: state.overview.pens,
        badges: state.overview.badges,
        isLoading: state.overview.isLoading,
        categoryId: state.overview.filteredCategory,
        categories: uniqueCategories,
        hasOpenedCategories: state.overview.hasOpenedCategories,
        currentDisplayLocale: state.overview.currentDisplayLocale || state.app.locale,
        activeBadges: state.overview.activeBadges,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setIsLoading: isLoading => dispatch(setIsLoading(isLoading)),
        changeCategory: categoryId => dispatch(changeCategory(categoryId)),
        openCategories: () => dispatch(openCategories()),
        closeCategories: () => dispatch(closeCategories()),
        setCurrentDisplayLocale: locale => dispatch(setCurrentDisplayLocale(locale)),
        fetchPens: () => dispatch(fetchPens()),
        fetchBadges: () => dispatch(fetchBadges()),
        setActiveBadges: activeBadges => dispatch(setActiveBadges(activeBadges)),
    };
}

const OverviewContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Overview);

export default OverviewContainer;
